import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const PenOutline = (props) => (
  <Icon viewBox="0 0 15 15" {...props}>
    <g>
      <title>Edit</title>
      <g fill="none" fillRule="evenodd">
        <path d="M13.7 4.624L12.306 6.02 8.97 2.679l1.394-1.396a1.183 1.183 0 0 1 1.634 0L13.7 2.987a1.16 1.16 0 0 1 0 1.637zM5.974 12.36l-1.328-1.33 3.51-3.513-.681-.682-3.51 3.514-1.327-1.33 5.65-5.658 3.337 3.34-5.651 5.659zm-4.548 1.214l.828-3.575 2.742 2.745-3.57.83zM14.38 2.306L12.679.6c-.801-.801-2.197-.8-2.996 0l-8.17 8.18L0 15l6.21-1.514 8.17-8.18a2.126 2.126 0 0 0 0-3z"
          fill="currentColor" />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default PenOutline;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/PenOutline.js